// extracted by mini-css-extract-plugin
module.exports = {"circleContainer":"NavigationCircles_circleContainer__1R3vZ"};